const fieldByAction = {
  UPDATE_FILTERED_ESTABLISHMENTS: 'filteredEstablishments',
  UPDATE_NO_PLATFORM_FILTERED_ESTABLISHMENTS: 'noPlatformFilteredEstablishments',
  UPDATE_FILTERED_REVIEWS: 'filteredReviews',
  UPDATE_NO_PLATFORM_FILTERED_REVIEWS: 'noPlatformFilteredReviews',
  UPDATE_ACTIVE_SUB_CATEGORIES: 'activeSubCategories',
  UPDATE_SELECTED_PLATFORM: 'selectedPlatform',
  UPDATE_SELECTED_CATEGORY: 'selectedCategory',
  UPDATE_SELECTED_SUB_CATEGORY: 'selectedSubCategory',
  UPDATE_SELECTED_DATES: 'selectedDates',
  UPDATE_SELECTED_SENTIMENT: 'selectedSentiment',
  UPDATE_SELECTED_ASPECT: 'selectedAspect',
  UPDATE_SELECTED_REGION: 'selectedRegion',
  UPDATE_SELECTED_YEAR: 'selectedYear',
  UPDATE_FETCHING_DATA: 'fetchingData',
  UPDATE_HAS_ERROR: 'hasError',
};

const reducer = (state, action) => {
  const field = fieldByAction[action.type];
  if (!field) {
    return state;
  }

  if (state[field] === action.payload) {
    return state;
  }

  return { ...state, [field]: action.payload };
};

export default reducer;
